import Swiper from 'swiper'
import { Scrollbar } from 'swiper/modules'
Swiper.use([Scrollbar])

const colVideoMobileSlider = (videoColContent) => {
    const videoColContentSwiper = new Swiper(videoColContent, {
        modules: [Scrollbar],
        slidesPerView: 1.1,
        spaceBetween: 10,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
    })
    if (window.matchMedia("(min-width: 768px)").matches)  {
        videoColContentSwiper.disable()
    } else {
        videoColContentSwiper.enable()
    }

    window.addEventListener('resize', function(){
        if (window.matchMedia("(min-width: 768px)").matches)  {
            videoColContentSwiper.disable()
        } else {
            videoColContentSwiper.enable()
        }
    })

}





export {colVideoMobileSlider}